<template>

    <div class="row">

        <div class="col-md-12">

            <div class="row" v-if="products.length === 0">
                <div class="col-12">
                    <div class="alert_msg">
                        <div class="">Please add items to your compare list </div>
                    </div>
                </div>
            </div>


            <div class="row" v-if="!showSkeleton">
                <template v-for="(data, index) in products" :key="data.id">
                    <div class="diam_block col-lg-3 col-md-4 col-6" :style="{ transitionDelay: `${index * 100}ms` }">
                        <div class="diam_box">
                            <NuxtLink :to="localePath(detailPath(data.slug))" @click.native="triggerGtag(data)">
                                <img height="300" width="300" :src="data.thumb_image"
                                    :alt="data.shape + ' shape thumb image'" />
                            </NuxtLink>
                            <div class="diam_details p-3">
                                <div class="">
                                    <p class="mb-1">{{ data.carat }} carat {{ data.shape }} diamond</p>
                                    <div class="four_cs">
                                        {{ data.color }} 
                                        <span>|</span> 
                                        {{ data.clarity }} 
                                        <span>|</span> 
                                        {{ data.cut }} 
                                        <span>|</span> 
                                        {{ data.report }}
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between mt-3 ">
                                    <h4 class="mb-0">{{ $formatPrice(data.price) }}</h4>

                                    

                                    <div class="for_desktop">
                                        <div class="checkbox_custom tooltip_box" @click="addToCompare(data)">
                                            <span
                                                :class="{ 'checked': data.is_compared_count === 1, 'unchecked': data.is_compared_count === 0 }"></span>
                                            <label class="mb-0"></label>
                                            <div class="tooltip_text" v-if="data.is_compared_count === 0">Add to Compare
                                            </div>
                                            <div class="tooltip_text" v-if="data.is_compared_count === 1">Remove From
                                                Compare</div>
                                        </div>
                                    </div>
                                </div>
                                <!--  <NuxtLink @click.native="triggerGtag(data)" :to="localePath(detailPath(data.slug))">
                                    <BasePrimary>view</BasePrimary>
                                </NuxtLink> -->
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="d-flex justify-content-center align-items-center" v-else>
                <img loading="lazy" width="246" class="loader_img mx-auto" height="246" alt="loader"
                    src="~/assets/assets/loader.svg">
            </div>

        </div>


    </div>



</template>

<script setup>
import { cyolistStore } from '~/stores/cyolist/cyolist';
import { compareStore } from '~/stores/diamond_compare/diamond_compare';

const { $toast, $looseViewGtag } = useNuxtApp()

const storeCyolist = cyolistStore()
const storeCompare = compareStore()


const route = useRoute()
const localePath = useLocalePath()

const moduleSubType = route.meta.moduleSubType

const showSkeleton = ref(true)

const products = computed(() => {
    return storeCyolist.getDiamondCompareListItems()
})

const triggerGtag = (data) => {
    if (moduleSubType === 'loose') {
        $looseViewGtag(data)
    }
}

const detailPath = (slug) => {

    if (['ring', 'earring', 'pendant'].includes(moduleSubType)) {

        return { name: 'cyo-diamond-detail-' + moduleSubType, params: { slug: slug } }
    }

    return { name: 'loose-detail', params: { slug: slug } }
}

const addToCompare = async (diamond) => {

    storeCompare.addToCompare({ moduleSubType: moduleSubType, diamond: diamond })
        .then((res) => {
            $toast('success', res.status, res.msg);
        })
}

onMounted(() => {
    storeCyolist.setDiamondCompareListItems({ moduleSubType: moduleSubType }).then(() => showSkeleton.value = false)
})


</script>

<style scoped>

.diam_box {
    border: solid 1px #e2e2e2;
    margin-bottom: 30px;
}

.diam_box p {
    color: #353535;
    font-size: 18px;
    line-height: 1.5;
    text-transform: capitalize;
    font-weight: 600;
    min-height: 50px;
}

.four_cs {
    display: block;
    color: #353535;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
}

.diam_box a img {
    min-height: 280px;
    object-fit: cover;
    max-height: 280px;
    width: 100%;
}

.diam_box h4 {
    color: var(--green);
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.compare_icons {
    cursor: pointer;
}

.alert_msg {
    display: flex;
    height: 30vh;
    justify-content: center;
    align-items: center;
    text-transform: capitalize;
}

@media(max-width: 1250px) {
    .diam_box a img {
        height: 220px;
    }
}
@media(max-width: 1100px) {
    .diam_box a img {
        height: 200px;
        min-height: auto;
    }
}
@media(max-width: 1024px) {
    .diam_box p {
        min-height: 73px;
    }
}
@media(max-width: 992px) {
    .diam_box a img {
        min-height: 280px;
    }
}
@media(max-width: 767px) {
    .four_cs{
        font-size: 14px;
    }
    .diam_block:nth-child(2n+2) {
        padding: 0;
        padding-right: 12px;
        padding-left: 5px;
    }
    .diam_block:nth-child(2n+1) {
        padding: 0;
        padding-left: 12px;
        padding-right: 5px;
    }
    .diam_block {
        margin-bottom: 10px !important;
    }
    .diam_box p {
        min-height: 42px;
    }
    .diam_box a img {
        min-height: 335px;
        max-height: inherit;
    }
    .diam_box img {
        width: 20px;
    }
    .diam_details {
        padding: 8px !important;
    }
    .diam_box p {
        font-size: 14px;
    }
    .diam_box h4 {
        color: var(--green);
        font-size: 16px;
    }
    .diam_box h4 span {
    font-size: 12px;
    margin-left: 5px;
}
    .grid_price {
        margin: 7px 0 5px !important;
    }
    .diam_details a button {
        height: 30px !important;
    }
    .diam_box {
        margin-bottom: 0;
    }
}
@media(max-width: 650px) {
    .diam_box a img {
        min-height: 250px;
    }
}
@media(max-width: 512px) {
    .diam_box a img {
        min-height: 175px;
    }
}
.fade-enter-active {
    transition: opacity 0.5s ease-in-out;
}
.fade-leave-active {
    display: none;
    transition: opacity 0;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
